export const notEmptyValue = (value): value is NonNullable<typeof value> => {
    return !!value;
};
